import { apiRequest } from './client'
import type { ApiTestimonial } from './types'

export function listTestimonials(
  activeOnly = true,
  featuredOnly = false,
): Promise<ApiTestimonial[]> {
  return apiRequest<ApiTestimonial[]>('/testimonials', {
    query: { activeOnly, featuredOnly },
  })
}
